import { render, staticRenderFns } from "./MediaCardMulti.vue?vue&type=template&id=807c1bd6&scoped=true&"
import script from "./MediaCardMulti.vue?vue&type=script&lang=js&"
export * from "./MediaCardMulti.vue?vue&type=script&lang=js&"
import style0 from "./MediaCardMulti.vue?vue&type=style&index=0&id=807c1bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807c1bd6",
  null
  
)

export default component.exports